
import { VueModule } from '@Foundation/utilities';
import HowToApply from './code/Scripts/components/how-to-apply';

export default VueModule({
  components: {
    HowToApply
  }
});
